import { Box, Link, Typography } from '@mui/material';
import { PlatformType } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import React, { FC, useMemo } from 'react';
import { useStyles } from './TournamentRules.styles';

interface TournamentRulesProps {
  tournament?: TournamentEntity;
}

export const TournamentRules: FC<TournamentRulesProps> = ({ tournament }) => {
  const { classes } = useStyles();

  const joinGameTimer = useMemo(
    () => tournament?.matchSetupSettings?.joinGameTimer ?? 0,
    [tournament?.matchSetupSettings?.joinGameTimer]
  );

  const isLolTournament = useMemo(() => {
    return tournament?.game?.platformType === PlatformType.LeagueOfLegends;
  }, [tournament?.game?.platformType]);

  if (!isLolTournament && joinGameTimer) {
    return (
      <Box className={classes.root}>
        <TournamentSettingsTitle>Tournament Rules</TournamentSettingsTitle>
        <Box className={classes.textContainer}>
          <Typography className={classes.text}>
            {`Each player must join the game ${joinGameTimer} minutes after the start of the game.`}
          </Typography>
          <Typography className={classes.text}>
            The team to which all team members did not join will be credited with losing the game.
          </Typography>
        </Box>
      </Box>
    );
  }

  if (!isLolTournament && !joinGameTimer) {
    return null;
  }

  const { breakTime } = tournament?.matchSetupSettings?.matchSetupSettings ?? {};

  return (
    <Box className={classes.root}>
      <TournamentSettingsTitle>Tournament Rules</TournamentSettingsTitle>
      <Box className={classes.textContainer}>
        <Box>
          <Typography className={classes.text}>
            Each player must check in 30 minutes before the tournament start time. Any team that
            does not have all team members checked in will be removed from the tournament.
          </Typography>
          <Typography className={classes.text}>
            Matches will be played in the standard, competitive game mode on the assigned map.
          </Typography>
          <Typography className={classes.text}>
            {`Matches are played concurrently with a ${breakTime} minute break between rounds.`}
          </Typography>
          <Typography className={classes.text}>
            OkLetsPlay isn&apos;t endorsed by Riot Games and doesn&apos;t reflect the views or
            opinions of Riot Games or anyone officially involved in producing or managing Riot Games
            properties. Riot Games, and all associated properties are trademarks or registered
            trademarks of Riot Games, Inc.
          </Typography>
        </Box>
        <Typography mt={1}>
          For a complete set of rules, please{' '}
          <Link
            target="_blank"
            className={classes.link}
            href="https://docs.okletsplay.com/legal#tournament-rules"
            underline="always"
          >
            click here
          </Link>
          .
        </Typography>
      </Box>
    </Box>
  );
};
